import StatementDetailsReducer from "@gerrieDev/Store/Pages/StatementDetails/StatementDetailsReducer";
import StatementsPageReducer from "@gerrieDev/Store/Pages/Statements/StatementsPageReducer";
import { combineReducers } from "redux";

const reducers = {
    statementDetails: StatementDetailsReducer,
    statements: StatementsPageReducer,
};

export type CustomPagesReducers = typeof reducers;

const customPagesReducer = combineReducers(reducers as any);

export default customPagesReducer;
